"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation refundEventOrders(
    $eventId: String!
    $dryRun: Boolean!
    $refundReason: String
    $eventType: String
  ) {
    refundEventOrders(
      eventId: $eventId
      dryRun: $dryRun
      refundReason: $refundReason
      eventType: $eventType
    ) {
      allRefunded
    }
  }
`;
exports.default = mutation;
//# sourceMappingURL=deleteEvent.mutation.js.map